import React from 'react';

interface CustomIconStarChart1Props extends React.SVGProps<SVGSVGElement> {}

export function CustomIconStarChart1({ height, width, ...props }: CustomIconStarChart1Props) {
  return (
    <svg
      width={width || 24}
      height={height || 24}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      {...props}
    >
      <path
        d="M12.8705 4.52728C12.7099 4.20506 12.3705 4 11.9978 4C11.6251 4 11.2888 4.20506 11.1252 4.52728L9.17691 8.40283L4.82586 9.02385C4.46227 9.07658 4.15927 9.32265 4.04716 9.65952C3.93505 9.9964 4.02595 10.3684 4.28653 10.6174L7.44377 13.6376L6.69839 17.9057C6.63779 18.2572 6.78929 18.6146 7.08926 18.8226C7.38923 19.0305 7.78615 19.0569 8.11339 18.8899L12.0009 16.8833L15.8883 18.8899C16.2156 19.0569 16.6125 19.0335 16.9124 18.8226C17.2124 18.6116 17.3639 18.2572 17.3033 17.9057L16.5549 13.6376L19.7121 10.6174C19.9727 10.3684 20.0667 9.9964 19.9515 9.65952C19.8364 9.32265 19.5364 9.07658 19.1728 9.02385L14.8187 8.40283L12.8705 4.52728Z"
        fill="currentColor"
      />
    </svg>
  );
}
